import { Validators } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { BaseUpdateComponent, BaseDataService, NotificationService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';
//import { NotifierService } from 'angular-notifier';
// import { NotificationsService } from 'angular2-notifications';
import { Okrug } from './okrug';
import { TranslateService } from '@ngx-translate/core';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-okrug-update',
  templateUrl: './okrug-update.component.html'
})
export class OkrugUpdateComponent extends BaseUpdateComponent<Okrug> implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService
  ) {
    super(activatedRoute, baseDataService, toastrService, translateService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.addValidatorToFc("Naziv", Validators.required, 'required', 'OKRUG.NAZIV.VALIDATION.REQUIRED');
    this.addValidatorToFc("Naziv", Validators.maxLength(200), 'maxlength', 'OKRUG.NAZIV.VALIDATION.MAXLENGTH');
    this.addValidatorToFc("DrzavaID", Validators.required, 'required', 'OKRUG.DRZAVAID.VALIDATION.REQUIRED');
  }

}
